import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=3958de60&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=3958de60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3958de60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3958de60')) {
      api.createRecord('3958de60', component.options)
    } else {
      api.reload('3958de60', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=3958de60&scoped=true&", function () {
      api.rerender('3958de60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27y3kBoSJZE1T/JS/teamMember.vue"
export default component.exports